import * as React from "react";
import { ReactComponent as CaretDownIcon } from "../../../assets/svg/caret-down.svg";
import { useClickOutside } from "../../../Hooks/useClickOutside";
import { useNavigate } from "react-router-dom";
import "./User.styles.scss";
import { Image } from "react-bootstrap";
import avatar from "../images/avatar.png";
import { MdLogout, MdSettings } from "react-icons/md";

const User = (props) => {
  const { visible, setVisible, ref, ref1 } = useClickOutside();

  const navigate = useNavigate();

  const toggleDropdown = () => {
    setVisible((prevS) => !prevS);
  };

  return (
    <div ref={ref1} className="user-dropdown">
      <div className="user-dropdown-container" onClick={toggleDropdown}>
        <Image src={avatar} alt="avatar" width={50} height={50} />

        <p className="user-dropdown-container-username">{props.username}</p>
        <CaretDownIcon className="user-dropdown-container-caret" />
      </div>

      {visible && (
        <div ref={ref} className="user-dropdown-dropdown">
          <p
            className="user-dropdown-dropdown-setting user-dropdown-dropdown-item"
            onClick={() => navigate("/settings")}
          >
            <MdSettings size={25} />
            Settings
          </p>
          <p
            className="user-dropdown-dropdown-logout user-dropdown-dropdown-item"
            onClick={() => props.onClick()}
          >
            <MdLogout size={25} />
            Logout
          </p>
        </div>
      )}
    </div>
  );
};

export default User;
